<template>
  <div class="row">
    <div class="medium-12 columns twelve">
      <div id="mainBody">
        <div id="rifsFrame" v-show="showIframe">
          <iframe
            :src="iframeSrc"
            width="100%"
            height="400px"
            ref="rifsWorksheet"
            name="rifsWorksheet"
            id="rifsWorksheet"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from 'axios';
import { log, error } from 'JS/global.js';
// import { countriesByCurrency, currencies } from '@/settings.js';
// import { reportCategories } from '@/settings.js';
// import Button from 'Components/button/Button.vue';
// import FormLabel from 'Components/form/FormLabel.vue';
// import IconSVG from 'Components/icon_svg/IconSVG.vue';
// import ValidatedForm from 'Components/form/ValidatedForm.vue';
// import ValidatedFormInput from 'Components/form/ValidatedFormInput.vue';

export default {
  name: 'regulatory_information_for_shipping',
  components: {
    // Button,
    // FormLabel,
    // IconSVG,
    // ValidatedForm,
    // ValidatedFormInput,
  },
  props: {
    formHandlerUrl: String,
  },
  data() {
    return {
      showIframe: false,
    };
  },
  computed: {
    iframeSrc: function() {
      if (this.showIframe) {
        return this.formHandlerUrl;
      }
      return '';
    },
  },
  methods: {},
  created() {},
  mounted() {
    this.showIframe = true;
  },
};
</script>
<style>
#rifsWorksheet {
  border: 1px solid gray;
  height: 600px;
}
#rifsWorksheet .iframe-wrapper,
#examples .iframe-wrapper iframe {
  height: 100%;
  width: 100%;
}
</style>
